export const validateInput = (fieldName, value) => {
    const blacklist = ['admin', 'user'];

    if (fieldName === 'totp') {
      const totpPartialRegex = /^\d{0,6}$/; // Allow up to 6 digits
      return totpPartialRegex.test(value);
    }
    // Always allow empty input (to allow deletion/backspace)
    if (value === "") 
        
        return true;
  
    if (fieldName ) {
      const allowedChars = /^[a-zA-Z0-9@._-]*$/;
     
      const noSpaces = !/\s/.test(value);
      const notBlacklisted = !blacklist.some(word =>
        value.toLowerCase().includes(word)
      );
      const hasAlphabet = /[a-zA-Z]/.test(value);
      const onlyAllowedChars = allowedChars.test(value);
  
      return noSpaces && notBlacklisted && hasAlphabet && onlyAllowedChars;
    }
  

    if (fieldName === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const noSpaces = !/\s/.test(value);
        return emailRegex.test(value) && noSpaces; 
      }
  
    return true;
  };
  